import { toast } from "react-toastify";
import { callApi } from "../../config/apiCall";
import { Api } from "../../config/apiEndPoints";
import { types } from "../constants/types";
import { call, put, takeLatest } from "redux-saga/effects";

const userDetails = sessionStorage.getItem("userDetails")
  ? JSON.parse(sessionStorage.getItem("userDetails"))
  : {};

  
export function* getCompanyAction(action) {
  try {
    const { limit = 5, page = 1, sort , plan_id, status ,only_without_plan } = action?.payload || {};
    // You can also dynamically build this query string if deliver and demo_status are needed
    const queryParams = new URLSearchParams({
      limit,
      page,
      ...(sort && { sort }),
      ...(plan_id && { plan_id }),
      ...(status && { status }),
      ...(only_without_plan && { only_without_plan })
    }).toString();

    const queryUrl = `?${queryParams}`;
    // //console.log(queryUrl);
    const response = yield call(
      callApi,
      Api?.GETCOMPANIES+queryUrl,
      "GET",
      null,
      userDetails?.token
    );
    if (response?.authenticated) {
      if (response?.valid) {
        if (response?.success) {
          yield put({
            type: types.GET_COMPANIES_SUCCESS,
            payload: response,
          });
        } else {
          toast.error(response?.data?.mssg);
        }
      } else {
        toast.error(response?.data?.mssg[0], {
          position: "top-center",
          autoClose: 1500,
        });
      }
    } 
  } catch (error) {
    yield put({ type: types.GET_COMPANIES_FAILED, error: error.response });
  }
}

export function* watchGetCompanyAction() {
  yield takeLatest(types.GET_COMPANIES_REQUEST, getCompanyAction);
}

  
export function* getPlanHistoryAction(action) {
  try {
    const response = yield call(
      callApi,
      `super-admin/companies/${action?.payload}/plans`,
      "GET",
      null,
      userDetails?.token
    );
    // //console.log("response response" ,response);
    if (response?.authenticated) {
      if (response?.valid) {
        if (response?.success) {
          yield put({
            type: types.GET_PLANHISTORY_SUCCESS,
            payload: response,
          });
        } else {
          toast.error(response?.data?.mssg);
        }
      } else {
        toast.error(response?.data?.mssg[0], {
          position: "top-center",
          autoClose: 1500,
        });
      }
    } else {
      // sessionStorage.removeItem("userDetails");
      // window.location.href = "/login";
    }
  } catch (error) {
    yield put({ type: types.GET_PLANHISTORY_FAILED, error: error.response });
  }
}

export function* watchGetPlanHistoryAction() {
  yield takeLatest(types.GET_PLANHISTORY_REQUEST, getPlanHistoryAction);
}



function* getServiceTypeAction(action) {
  try {
    const response = yield call(
      callApi,
      `${action.payload?action.payload:"super-admin/services"}`,
      "GET",
      null,
      userDetails?.token
    );
    // //console.log("response response" ,response);
      if (response?.valid) {
        if (response?.success) {
          yield put({
            type: types.GET_SERVICETYPE_SUCCESS,
            payload: response,
          });
        } 
      } 
  } catch (error) {
    yield put({ type: types.GET_SERVICETYPE_FAILED, error: error.response });
  }
}

export function* watchGetServiceTypeAction() {
  yield takeLatest(types.GET_SERVICETYPE_REQUEST, getServiceTypeAction);
}



// get super admin list 

  
export function* getSuperAdminsAction(action) {
  try {
    const { limit = 5, page = 1, sort = 'last_7_days', plan_id, status ,only_without_plan } = action?.payload || {};
    // You can also dynamically build this query string if deliver and demo_status are needed
    const queryParams = new URLSearchParams({
      limit,
      page,
      sort,
      ...(plan_id && { plan_id }),
      ...(status && { status }),
      ...(only_without_plan && { only_without_plan })
    }).toString();

    const queryUrl = `?${queryParams}`;
    // //console.log(queryUrl);
    const response = yield call(
      callApi,
      Api?.CREATEADMIN+queryUrl,
      "GET",
      null,
      userDetails?.token
    );
    if (response?.authenticated) {
      if (response?.valid) {
        if (response?.success) {
          yield put({
            type: types.GET_SUPERADMIN_SUCCESS,
            payload: response,
          });
        } else {
          yield put({
            type: types.GET_SUPERADMIN_SUCCESS,
            payload: [],
          });
          toast.error(response?.data?.mssg);
        }
      } else {
        toast.error(response?.data?.mssg[0]);
      }
    } 
  } catch (error) {
    yield put({ type: types.GET_SUPERADMIN_FAILED, error: error.response });
  }
}

export function* watchGetSuperAdminsAction() {
  yield takeLatest(types.GET_SUPERADMIN_REQUEST, getSuperAdminsAction);
}





function* getManagePolicyAction(action) {
  try {
    // //console.log("action" ,action?.payload);
    const path =  action?.payload?.companyId ? `policies`:`/super-admin/companies/${action.payload}/policies` 
    const response = yield call(
      callApi,
      path,
      "GET",
      null,
      userDetails?.token
    );
    // //console.log("plociy response" ,response);
    if (response?.authenticated) {
      if (response?.valid) {
        if (response?.success) {
          yield put({
            type: types.GET_MANAGEPOLICY_SUCCESS,
            payload: response.data,
          });
        } else{
          // yield put({
          //   type: types.GET_MANAGEPOLICY_SUCCESS,
          //   payload: {},
          // });
        }
      } 
    }
  } catch (error) {
    yield put({ type: types.GET_MANAGEPOLICY_FAILED, error: error.response });
  }
}

export function* watchGetManagePolicyAction() {
  yield takeLatest(types.GET_MANAGEPOLICY_REQUEST, getManagePolicyAction);
}

